import { render } from "./Releases.vue?vue&type=template&id=9120a072&ts=true"
import script from "./Releases.vue?vue&type=script&lang=ts"
export * from "./Releases.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__